/**
 * Use for adding emergency stop chat feature by showing chat unavailable indicator to the customer
 */
export const HELP_CENTER_CHAT_EMERGENCY_STOP_230308 =
  'HELP_CENTER_CHAT_EMERGENCY_STOP_230308';
